import Enums from "../../../enums/enums";
const state = {
  registerLoadingStatus: Enums.LoadingStatusType.None,
  getRegisterReponseType: null,
  getRegister: null,
  googleProfile: null,
  microsoftProfile: null,
  acceptInvitationLoadingStatus: Enums.LoadingStatusType.None,
  acceptInvitationLoadingStatusV2: Enums.LoadingStatusType.None,
  acceptInvitationModel: {},
  acceptInvitationModelV2: {},
  insertUserProfileConsentLoadingStatus: Enums.LoadingStatusType.None,
  getUserProfileConsentLoadingStatus: Enums.LoadingStatusType.None,
  registerModel: null,
  userprofileConsentModel: null,
  getUserSenderInvitationDetailLoadingStatus: Enums.LoadingStatusType.None,
  getUserSenderInvitationDetail: {},
  getInvitationInRoleLoadingStatus: Enums.LoadingStatusType.None,
  getInvitationInRole: [],
};

const getters = {
  GetRegisterLoadingStatus: (state) => {
    return state.registerLoadingStatus;
  },
  GetRegister: (state) => {
    return state.getRegister;
  },
  GetGoogleProfile: (state) => {
    return state.googleProfile;
  },
  GetMicrosoftProfile: (state) => {
    return state.microsoftProfile;
  },
  GetAcceptInvitationModel: (state) => {
    return state.acceptInvitationModel;
  },
  GetAcceptInvitationModelV2: (state) => {
    return state.acceptInvitationModelV2;
  },
  GetAcceptInvitationLoadingStatus: (state) => {
    return state.acceptInvitationLoadingStatus;
  },
  GetAcceptInvitationLoadingStatusV2: (state) => {
    return state.acceptInvitationLoadingStatusV2;
  },
  GetInsertUserProfileConsentLoadingStatus: (state) => {
    return state.insertUserProfileConsentLoadingStatus;
  },
  GetUserProfileConsentLoadingStatus: (state) => {
    return state.getUserProfileConsentLoadingStatus;
  },
  GetRegisterModel: (state) => {
    return state.registerModel;
  },
  GetUserprofileConsentModel: (state) => {
    return state.userprofileConsentModel;
  },
  GetUserSenderInvitationDetailLoadingStatus: (state) => {
    return state.getUserSenderInvitationDetailLoadingStatus;
  },
  GetUserSenderInvitationDetail: (state) => {
    return state.getUserSenderInvitationDetail;
  },
  GetInvitationInRoleLoadingStatus: (state) => {
    return state.getInvitationInRoleLoadingStatus;
  },
  GetInvitationInRole: (state) => {
    return state.getInvitationInRole;
  },
};
export { getters, state };
